import { render, staticRenderFns } from "./autotemplate.vue?vue&type=template&id=05e1e93b&scoped=true&"
import script from "./autotemplate.vue?vue&type=script&lang=js&"
export * from "./autotemplate.vue?vue&type=script&lang=js&"
import style0 from "./autotemplate.vue?vue&type=style&index=0&id=05e1e93b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e1e93b",
  null
  
)

export default component.exports